// --- TEMP ---
// Workaround to disable some features to allow testing
// --- Features/Changes ---
// - Disabling mobile verification steps
// - Adding dummy number for user phone number setup in personal information review step
// - Reverting back to 'phoneNumber' field in user profile
export const useMobileVerificationDisabled = () => {
  const DUMMY_MOBILE_NUMBER = '+61412345678';

  const disableMobileVerify =
    localStorage.getItem('DISABLE_MOBILE_VERIFY') === 'true';
  return {
    isMobileVerificationDisabled: disableMobileVerify,
    DUMMY_MOBILE_NUMBER,
  };
};
